import type { ReactNode } from 'react';
import { LotteryFAQ } from '../../../lotteries/LotteryFAQ/LotteryFAQ';
import type { LotteryName } from '../../../lottery-purchases/types';
import type { ResultsConfig } from '../../types';
import { ResultsPageClient } from './ResultsPageClient';

type ResultsPageComponentProps = {
  lotteryName: LotteryName;
  config?: ResultsConfig;
  backFallbackUrl?: string;
  pageHeaderActions?: ReactNode;
};

function ResultsPageComponent({ lotteryName, config, backFallbackUrl, pageHeaderActions }: ResultsPageComponentProps) {
  return (
    <ResultsPageClient lotteryName={lotteryName} config={config} backFallbackUrl={backFallbackUrl} className="mb-10" pageHeaderActions={pageHeaderActions}>
      <LotteryFAQ lotteryName={lotteryName} faqPage="results" />
    </ResultsPageClient>
  );
}

export { ResultsPageComponent, type ResultsPageComponentProps };
